import React from "react";
import NotFound from "./NotFound";

function About() {
  return (
    <div className="unloadPage">
      <NotFound />
    </div>
  );
}

export default About;
